import { FollowupTask } from "@/types/followupTask";
import { Client } from "@/types/page";
import { createContext } from "react";

export type Tasks = {
    [key: Client["id"]]: FollowupTask[];
};

export type TaskEvent = {
    followupTask: FollowupTask;
};

export const initialFollowupTaskContext = {
    allTasks: {} as Tasks,
    shownTasks: {} as Tasks,
    shownTasksWithoutSnoozed: {} as Tasks,
    shownTasksEligibleForDraft: {} as Tasks,
    numberOfClientsWithTasks: 0,
    getClientTasks: (_client_id: Client["id"]) => [] as FollowupTask[],
    getClientTasksWithoutSnoozed: (_client_id: Client["id"]) =>
        [] as FollowupTask[],
    deleteTask: (_task: FollowupTask) => {},
    upsertTask: (_task: FollowupTask) => {},
    markTaskAsDoneVisually: (_task: FollowupTask) => {},
    undoTaskCompletionVisually: (_task: FollowupTask) => {},
};

export const FollowupTaskContext = createContext(initialFollowupTaskContext);
